import React from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import PORTAvatar from "../PORTAvatar";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import RenderDate from "../../../Common/Date/RenderDate";
import DevelopmentNeedStatusIcon from "../DevelopmentNeed/DevelopmentNeedStatusIcon";
import PDPDetails from "./PDPDetails";

function ActionlButton({ id, status }) {
    let label = "View";
    let variant = "contained";
    let color = "neutral";
    let textColor = "rgba(0,0,0,0.7)";
    let endIcon = <KeyboardArrowRightOutlinedIcon />;

    if (status === "open") {
        label = "Continue";
        color = "primary";
        textColor = "#FFF";
        endIcon = <KeyboardArrowRightOutlinedIcon style={{ color: "#FFF" }} />;
    }

    return (
        <Button
            variant={variant}
            color={color}
            disableElevation={true}
            aria-label="Personal development plan"
            component={Link}
            to={`/portfolio/pdps/${Number(id) || ""}`}
            endIcon={endIcon}
        >
            <Typography variant={"span"} sx={{ color: textColor }}>
                {label}
            </Typography>
        </Button>
    );
}

function PDPCard({ pdp }) {
    return (
        <Card className="card">
            <CardHeader
                disableTypography
                avatar={
                    <PORTAvatar
                        type={"pdp"}
                        badge={pdp?.status === "completed" ? "checked" : ""}
                    />
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        <ActionlButton id={pdp.id} status={pdp.status} />
                    </Stack>
                }
                title={
                    <Typography component="h3" className="card-header-title">
                        {pdp.title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {!!pdp?.dateStart && (
                            <RenderDate date={pdp.dateStart} />
                        )}
                        &nbsp;-&nbsp;
                        {!!pdp?.dateEnd && <RenderDate date={pdp.dateEnd} />}
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <PDPDetails owner={pdp?.owner} appraiser={pdp?.appraiser} />
                </Box>
            </CardContent>
            <CardContent>
                <Box className="card-content">
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        spacing={0}
                    >
                        {pdp?.developmentNeeds?.length > 0 &&
                            pdp.developmentNeeds.map((devNeed) => (
                                <DevelopmentNeedStatusIcon
                                    key={devNeed.id}
                                    status={devNeed?.status}
                                />
                            ))}
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    );
}

export default PDPCard;
